import { IProduct } from '../../types/analytics';
import { IApplicationState } from '../../types/redux';

export const selectProductById =
  (id: number) =>
  (state: IApplicationState): IProduct => {
    return state.analytics.products.entities[id];
  };
